import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoneyCircle20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMoneyCircle20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18m.75-14.014a.75.75 0 0 0-1.5 0v.3c-.544.077-1.022.243-1.4.545-.61.486-.798 1.188-.798 1.9 0 .885.458 1.496 1.019 1.913.518.386 1.182.65 1.73.869l.017.006c.6.24 1.078.43 1.418.673.304.217.402.404.402.642 0 .404-.193.704-.532.932-.36.243-.854.374-1.297.374-.6 0-.985-.21-1.221-.403a1.6 1.6 0 0 1-.312-.34l-.006-.01a.75.75 0 0 0-1.32.71l.662-.35c-.663.35-.662.35-.662.351l.001.002.002.004.004.008.012.021.037.062q.045.073.129.184a3 3 0 0 0 .505.52 3.3 3.3 0 0 0 1.61.7v.415a.75.75 0 0 0 1.5 0v-.488a3.7 3.7 0 0 0 1.194-.516c.665-.448 1.194-1.176 1.194-2.176 0-.875-.476-1.466-1.031-1.863-.496-.354-1.129-.605-1.66-.816l-.075-.03c-.595-.236-1.07-.434-1.405-.684-.3-.223-.415-.43-.415-.71 0-.46.115-.632.234-.728.163-.13.528-.272 1.328-.272.666 0 1.07.222 1.301.412a1.5 1.5 0 0 1 .3.333l.005.008a.75.75 0 0 0 1.341-.67l-.673.33.673-.331-.001-.003-.002-.003-.005-.01-.012-.022-.036-.065a3 3 0 0 0-.64-.729 3.3 3.3 0 0 0-1.615-.702zm-2.48 7.4v.001zm0 0q0-.002 0 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoneyCircle20Filled);
